// extracted by mini-css-extract-plugin
export var backBone = "_g-3";
export var blocks = "_g-c";
export var bone = "_g-0";
export var buttonBone = "_g-7";
export var cardBone = "_g-r";
export var cardLineBone = "_g-t";
export var cardTitleBone = "_g-s";
export var heroImageBone = "_g-q";
export var imageGridBone = "_g-m";
export var imageGridCellBone = "_g-n";
export var leftInner = "_g-2";
export var phoneBone = "_g-p";
export var phoneWrap = "_g-o";
export var pillboxBone = "_g-u";
export var sidebar = "_g-8";
export var sidebarTimelineItem = "_g-9";
export var skeletonPulse = "_g-1";
export var spacer = "_g-4";
export var subtitleBone = "_g-6";
export var timelineIconBone = "_g-a";
export var timelineTextBone = "_g-b";
export var titleBone = "_g-5";
export var toggleIconBone = "_g-e";
export var toggleLabelBone = "_g-f";
export var toggleRowBone = "_g-d";
export var toggleSwitchBone = "_g-g";
export var videoAreaBone = "_g-i";
export var videoBone = "_g-h";
export var videoFooterBone = "_g-j";
export var videoFooterIconBone = "_g-k";
export var videoFooterTextBone = "_g-l";